export const SET_ACTIVE_GRAPH_INDEX = 'reports/venues/SET_ACTIVE_GRAPH_INDEX';
export const setActiveGraphIndex = index => ({ type: SET_ACTIVE_GRAPH_INDEX, index });

export const SET_VIEW_BY_UNIT = 'reports/venues/SET_VIEW_BY_UNIT';
export const setViewByUnit = viewByUnit => ({ type: SET_VIEW_BY_UNIT, viewByUnit });

export const SET_VIEW_BY_RANGE_DAY = 'reports/venues/SET_VIEW_BY_RANGE_DAY';
export const setViewByRangeDay = viewByRange => ({ type: SET_VIEW_BY_RANGE_DAY, viewByRange });

export const SET_VIEW_BY_RANGE_WEEK = 'reports/venues/SET_VIEW_BY_RANGE_WEEK';
export const setViewByRangeWeek = viewByRange => ({ type: SET_VIEW_BY_RANGE_WEEK, viewByRange });

export const SET_VIEW_BY_RANGE_MONTH = 'reports/venues/SET_VIEW_BY_RANGE_MONTH';
export const setViewByRangeMonth = viewByRange => ({ type: SET_VIEW_BY_RANGE_MONTH, viewByRange });

export const SET_VIEW_BY_RANGE_YEAR = 'reports/venues/SET_VIEW_BY_RANGE_YEAR';
export const setViewByRangeYear = viewByRange => ({ type: SET_VIEW_BY_RANGE_YEAR, viewByRange });

export const SET_SELECTED_VENUE_IDS = 'reports/venues/SET_SELECTED_VENUE_IDS';
export const setSelectedVenueIds = venueIds => ({ type: SET_SELECTED_VENUE_IDS, venueIds });

export const initialState = {
  activeGraphIndex: 5, // most recent column on last 6 months view
  selectedVenueIds: [],
  viewByUnit: 'month',
  viewByRangeDay: 14,
  viewByRangeWeek: 4,
  viewByRangeMonth: 6,
  viewByRangeYear: 3,
};

const reducer = (state = initialState, { type, ...action }) => {
  let newActiveGraphIndex;
  switch (type) {
    case SET_ACTIVE_GRAPH_INDEX:
      return { ...state, activeGraphIndex: Number(action.index) };
    case SET_VIEW_BY_UNIT:
      switch (action.viewByUnit) {
        case 'day':
          newActiveGraphIndex = state.viewByRangeDay;
          break;
        case 'week':
          newActiveGraphIndex = state.viewByRangeWeek;
          break;
        case 'month':
          newActiveGraphIndex = state.viewByRangeMonth;
          break;
        case 'year':
          newActiveGraphIndex = state.viewByRangeYear;
          break;
        default:
          newActiveGraphIndex = state.viewByRangeMonth;
      }
      newActiveGraphIndex -= 1;
      return { ...state, activeGraphIndex: newActiveGraphIndex, viewByUnit: action.viewByUnit };
    case SET_VIEW_BY_RANGE_DAY:
      return { ...state, activeGraphIndex: action.viewByRange - 1, viewByRangeDay: action.viewByRange };
    case SET_VIEW_BY_RANGE_WEEK:
      return { ...state, activeGraphIndex: action.viewByRange - 1, viewByRangeWeek: action.viewByRange };
    case SET_VIEW_BY_RANGE_MONTH:
      return { ...state, activeGraphIndex: action.viewByRange - 1, viewByRangeMonth: action.viewByRange };
    case SET_VIEW_BY_RANGE_YEAR:
      return { ...state, activeGraphIndex: action.viewByRange - 1, viewByRangeYear: action.viewByRange };
    case SET_SELECTED_VENUE_IDS:
      return { ...state, selectedVenueIds: [...action.venueIds] };
    default:
      return state;
  }
};

export default reducer;
